import styled from "@emotion/styled";
import type { TransitionStatus } from "react-transition-group";

export type ContainerProps = {
  $state: TransitionStatus;
  $timeout: number;
};

export const Container = styled.div<ContainerProps>`
  display: ${({ $state }) => ($state === "exited" ? "none" : "block")};

  opacity: ${({ $state }) => ($state === "entered" ? 1 : 0)};

  transition: ${({ $timeout }) => `opacity ${$timeout / 1000}s ease-in-out`};
`;
